export const FREQUENCIES = {
    DAILY: "Daily",
    WEEKLY: "Weekly"
}